// extracted by mini-css-extract-plugin
export default {"popup":"OpacityPopup_popup__Jyo-0","label":"OpacityPopup_label__3LPHN","row":"OpacityPopup_row__ILKdj","slider":"OpacityPopup_slider__Bsx0L","value":"OpacityPopup_value__-JFZd"};